import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { LocalStorageKeys } from '../executive/executive.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (!sessionStorage.getItem(LocalStorageKeys.TOKEN)) {
      this.router.navigate(['login']);
      return false;
    }

    return true;
  }
}
